import { $document } from '../utils/globals.js';

const handleCartCount = () => {
    function setCookie(name, value, eDate, domain) {
        const date = new Date(Date.parse(eDate));
        const expires = "; expires=" + date.toUTCString();
        document.cookie = name + "=" + (value || "") + expires + ";domain=" + domain + "; path=/";
    }
    $document.ready(function () {
        const isTokenNameAvailable = $(".header__cart").data("islogin");
        const cartPresent = document.cookie.toLowerCase().includes('_cart');
        if (cartPresent || isTokenNameAvailable) {
            var request = {
                "getcartlines": "false"
            };
            $.ajax({
                url: '/b2c-api/getcart',
                data: request,
                accept: 'application/json; charset=utf-8',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function(data) {
                    var cookies = data.CookieCollection;
                    if (cookies) {
                        jQuery.each(cookies,
                            function(i, cookie) {
                                setCookie(cookie.Value.Name, cookie.Value.Value, cookie.Value.Expires, cookie.Value.Domain);
                            });
                    }
                    if(data.TotalItems > 0)
                    {
                        $(".header__cart-items").removeAttr("style");
                        $('.header__cart-items').text(data.TotalItems);
                    }
                }
            });
        }
    });
};

handleCartCount();